import{jsx as r}from"react/jsx-runtime";import o from"../icons/SpinnerIcon.js";import{SpinnerContainer as t}from"../styles.js";const s=()=>r(t,{children:r(o,{})});export{s as default};
